import * as React from 'react';
import { Grid, useTheme } from '@mui/material';
import InputWithLabel from '@components/InputWithLabel';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';

export default function({
  currentState,
  handleChangeInput,
  handleTaxRateChange,
  taxRates,
  selectedTaxRate,
}) {
  const theme = useTheme();
  return (
    <Grid container spacing={1.875}>
      <Grid item xs={8}>
        <InputWithLabel
          type="number"
          label="Price"
          placeholder="Set price"
          startAdornment="€"
          name="priceIncludingTax"
          value={currentState?.priceIncludingTax}
          handleChangeInput={handleChangeInput}
        />
      </Grid>
      <Grid item xs={4}>
        <ToggleButtonGroup
          color="primary"
          sx={{
            marginTop: '26px',
            border: `1px solid #43566C`,
            fontSize: theme.fonts.sizes.font14PX,
            color: theme.colors.light.lightCyan,
            height: 57.75,
            cursor: 'pointer',
            backgroundColor: theme.colors.light.lightBlue,
            borderRadius: 4.25,
          }}
          fullWidth={true}
          exclusive
          value={selectedTaxRate}
          onChange={e => {
            handleTaxRateChange(parseFloat(e.target.value));
          }}
        >
          {taxRates.map(rate => (
            <ToggleButton
              value={rate.amount}
              key={rate.amount}
              sx={{ color: theme.colors.light.lightCyan }}
              aria-label={rate.name}
            >
              {rate.amount * 100}%
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  );
}
